<div class="loader-container" [ngClass]="containerClasses">
    <div class="documents-flow">
        @for (doc of documentArray; track doc) {
        <div class="document" [style.--animation-delay]="(doc * 0.3) + 's'" [style.--color-index]="doc % 8"></div>
        }
    </div>
    @if (showText) {
    <div class="loading-text">
        {{ text }}<span class="dots">...</span>
    </div>
    }
</div>
